module.exports = __webpack_public_path__ + "img/achbar_yes.4d4b2e6e.png";